import AMLDetailList from './AMLDetailsList';

export default AMLDetailList;
